import { render } from "./PageListarFinalidade.vue?vue&type=template&id=fdc583de"
import script from "./PageListarFinalidade.vue?vue&type=script&lang=js"
export * from "./PageListarFinalidade.vue?vue&type=script&lang=js"

import "./PageListarFinalidade.vue?vue&type=style&index=0&id=fdc583de&lang=css"
/* custom blocks */
import block0 from "./PageListarFinalidade.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__